import type { InputHTMLAttributes } from 'react';

interface AuthInputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  hint?: string;
}

export default function AuthInput({ label, hint, className = '', ...rest }: AuthInputProps) {
  return (
    <div className="mb-3.5">
      {label && (
        <label className="block text-[13px] font-semibold text-ink mb-1.5">{label}</label>
      )}
      <input
        {...rest}
        className={`w-full outline-none transition-[border-color,box-shadow] duration-150 ${className}`}
        style={{
          padding: '13px 16px',
          borderRadius: 14,
          border: '1px solid var(--color-hairline-strong)',
          background: 'var(--color-surface)',
          fontSize: 15,
          color: 'var(--color-ink)',
          fontFamily: 'inherit',
        }}
        onFocus={e => {
          e.currentTarget.style.borderColor = 'var(--color-ink)';
          e.currentTarget.style.boxShadow = 'var(--shadow-focus)';
        }}
        onBlur={e => {
          e.currentTarget.style.borderColor = 'var(--color-hairline-strong)';
          e.currentTarget.style.boxShadow = 'none';
        }}
      />
      {hint && <p className="text-xs text-ink-muted mt-1.5 mb-0">{hint}</p>}
    </div>
  );
}
